module.exports = __webpack_public_path__ + "img/2_239.8d8f166f.png";